/* NYTRON cart drawer — slide-in side cart with AJAX add/change/remove.
   Pairs with sections/nytron-cart-drawer.liquid + snippets/nytron-cart-contents.liquid + sections/nytron-header.liquid */

(function () {
  'use strict';

  var ROUTES = (window.routes && window.routes.cart_add_url) ? window.routes : {
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_update_url: '/cart/update',
    cart_url: '/cart'
  };

  var drawer = document.querySelector('[data-nt-cart]');
  if (!drawer) return;

  var body = drawer.querySelector('[data-nt-cart-body]');
  var foot = drawer.querySelector('[data-nt-cart-foot]');
  var subtotalEl = drawer.querySelector('[data-nt-subtotal]');
  var totalsEl = drawer.querySelector('[data-nt-cart-totals]');
  var headerCount = drawer.querySelector('[data-nt-cart-count-text]');
  /* The config <script> is a SIBLING of [data-nt-cart] inside the section wrapper,
     not a child of it, so the drawer-scoped lookup alone always returned null and
     every setting below silently fell back to its hardcoded default. Keep the
     drawer-scoped lookup first in case a future layout nests it. */
  var configEl = drawer.querySelector('[data-nt-cart-config]') ||
                 document.querySelector('[data-nt-cart-config]');
  var config = {};
  try { config = configEl ? JSON.parse(configEl.textContent) : {}; } catch (e) { config = {}; }

  /* ---------- Free gift ($0 product attached to every non-empty cart) ----------
     GIFT_ID is a variant id as a Number; /cart.js returns variant ids as Numbers too,
     so compare loosely-typed values through Number() rather than ===. */
  var GIFT = config.free_gift || null;
  var GIFT_ID = GIFT && GIFT.id ? Number(GIFT.id) : 0;

  function isGiftItem(item) {
    if (!GIFT_ID || !item) return false;
    return Number(item.variant_id || item.id) === GIFT_ID;
  }

  /* The product page tick box is the customer's opt-out. Pages without one (hero,
     final CTA, sticky bar) attach the gift by default, so every route into the cart
     behaves the same unless the customer has actively said no. */
  function giftWanted() {
    if (!GIFT_ID) return false;
    var cb = document.querySelector('[data-nt-warranty-checkbox]');
    return cb ? !!cb.checked : true;
  }

  /* ---------- Money formatter ---------- */
  function formatMoney(cents) {
    var fmt = config.money_format || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amountNoDecimals = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals.replace(/,/g, '.'));
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------- Open / close ---------- */
  var lastFocus = null;

  function openDrawer() {
    if (drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nt-cart-open');
    var panel = drawer.querySelector('.nt-cart__panel');
    if (panel) {
      setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (e) {} }, 60);
    }
  }
  function closeDrawer() {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nt-cart-open');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-nt-cart-open]');
    if (trigger) { e.preventDefault(); openDrawer(); return; }
    var closer = e.target.closest('[data-nt-cart-close]');
    if (closer && drawer.contains(closer)) {
      e.preventDefault(); closeDrawer(); return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  /* ---------- Render helpers ---------- */
  function renderEmpty() {
    return [
      '<div class="nt-cart__empty">',
      '<svg class="nt-cart__empty-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">',
      '<path d="M4 6h16l-1.5 12.5a1 1 0 0 1-1 .9H6.5a1 1 0 0 1-1-.9L4 6z" stroke="currentColor" stroke-width="1.4"/>',
      '<path d="M8 6V4a4 4 0 0 1 8 0v2" stroke="currentColor" stroke-width="1.4"/>',
      '</svg>',
      '<p class="nt-cart__empty-title">Your cart is empty</p>',
      '<p class="nt-cart__empty-sub">Add a kit to get started.</p>',
      '<a href="/collections/all" class="nt-cart__empty-cta" data-nt-cart-close>Continue shopping</a>',
      '</div>'
    ].join('');
  }

  /* Pick the larger of: original_line_price (Shopify discount-aware) and
     variant.compare_at_price × qty (MSRP). Either >, both, or neither may apply. */
  function wasLinePrice(item) {
    var was = item.original_line_price || 0;
    var compare = item.variant && item.variant.compare_at_price ? item.variant.compare_at_price : 0;
    /* /cart.js sometimes uses item.compare_at_price directly */
    if (!compare && item.compare_at_price) compare = item.compare_at_price;
    var price = item.variant && item.variant.price ? item.variant.price : item.price;
    if (compare && price && compare > price) {
      var compareLine = compare * (item.quantity || 1);
      if (compareLine > was) was = compareLine;
    }
    return was;
  }

  function renderLineItem(item, index) {
    var hasDefaultVariant = item.variant_title == null || item.variant_title === '';
    var gift = isGiftItem(item);
    var was = wasLinePrice(item);
    var wasPriceHtml = '';
    if (was > item.final_line_price) {
      wasPriceHtml = '<span class="nt-cart__price-was">' + formatMoney(was) + '</span>';
    }
    /* /cart.js line items carry no compare_at_price, so the gift's $97 anchor would
       survive the Liquid first paint and then vanish on the first JS re-render. Take
       it from the section config instead, which reads it off the variant. */
    if (gift && GIFT.value_formatted) {
      wasPriceHtml = '<span class="nt-cart__price-was">' + escapeHtml(GIFT.value_formatted) + '</span>';
    }
    /* Badges: sale markdown (compare_at) + one per Shopify discount, each with the
       real code/title and amount. Mirrors snippets/nytron-cart-contents.liquid. */
    var TAG_ICON = '<svg width="10" height="10" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 2h5.5L14 8.5 8.5 14 2 7.5V2z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="5.5" cy="5.5" r="1" fill="currentColor"/></svg>';
    var discountsHtml = '';
    var compare = (item.variant && item.variant.compare_at_price) || item.compare_at_price || 0;
    var unitPrice = (item.variant && item.variant.price) || item.price || 0;
    /* The gift's compare-at is a value anchor, not a markdown, so it gets no sale badge. */
    if (!gift && config.show_sale_badge !== false && compare && unitPrice && compare > unitPrice) {
      var saleSaving = (compare - unitPrice) * (item.quantity || 1);
      discountsHtml += '<span class="nt-cart__discount">' + TAG_ICON + escapeHtml(config.sale_badge_label || 'Sale') + ' −' + formatMoney(saleSaving) + '</span>';
    }
    if (item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
      for (var i = 0; i < item.line_level_discount_allocations.length; i++) {
        var d = item.line_level_discount_allocations[i];
        if (d.discount_application && d.discount_application.title) {
          var amt = typeof d.amount === 'number' ? ' −' + formatMoney(d.amount) : '';
          discountsHtml += '<span class="nt-cart__discount">' + TAG_ICON + escapeHtml(d.discount_application.title) + amt + '</span>';
        }
      }
    }
    var imgHtml = item.image
      ? '<img src="' + escapeHtml(item.image.replace(/(\?|&)width=\d+/g, '') + (item.image.indexOf('?') >= 0 ? '&' : '?') + 'width=200') + '" alt="' + escapeHtml(item.product_title) + '" width="72" height="72" loading="lazy">'
      : '';
    /* Gift line: a note + "× N" (quantity mirrors the kit automatically) + a remove
       button, and the free label instead of $0.00. Mirrors the is_gift branch of
       nytron-cart-contents.liquid. */
    var controlsHtml = gift
      ? [
          '<div class="nt-cart__row">',
          '<span class="nt-cart__gift-note">' + escapeHtml(GIFT.note || 'Included with your kit') + '</span>',
          (item.quantity > 1 ? '<span class="nt-cart__gift-qty">× ' + item.quantity + '</span>' : ''),
          '<button type="button" class="nt-cart__remove" data-nt-remove aria-label="Remove item">',
          '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">',
          '<path d="M3 4h10M6 4V2.5h4V4M5 4l.5 9a1 1 0 0 0 1 .9h3a1 1 0 0 0 1-.9L11 4" stroke="currentColor" stroke-width="1.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>',
          '</svg>',
          '</button>',
          '</div>'
        ].join('')
      : [
          '<div class="nt-cart__row">',
          '<div class="nt-cart__qty" role="group" aria-label="Quantity">',
          '<button type="button" data-nt-qty-dec aria-label="Decrease">−</button>',
          '<span class="nt-cart__qty-val" data-nt-qty-val>' + item.quantity + '</span>',
          '<button type="button" data-nt-qty-inc aria-label="Increase">+</button>',
          '</div>',
          '<button type="button" class="nt-cart__remove" data-nt-remove aria-label="Remove item">',
          '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">',
          '<path d="M3 4h10M6 4V2.5h4V4M5 4l.5 9a1 1 0 0 0 1 .9h3a1 1 0 0 0 1-.9L11 4" stroke="currentColor" stroke-width="1.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>',
          '</svg>',
          '</button>',
          '</div>'
        ].join('');
    var priceHtml = gift
      ? '<span class="nt-cart__price-free">' + escapeHtml(GIFT.free_label || 'FREE') + '</span>'
      : formatMoney(item.final_line_price);

    return [
      '<li class="nt-cart__item' + (gift ? ' nt-cart__item--gift' : '') + '" data-nt-line="' + index + '" data-nt-line-key="' + escapeHtml(item.key) + '">',
      '<a href="' + escapeHtml(item.url) + '" class="nt-cart__thumb" tabindex="-1" aria-hidden="true">' + imgHtml + '</a>',
      '<div class="nt-cart__meta">',
      '<a href="' + escapeHtml(item.url) + '" class="nt-cart__name">' + escapeHtml(item.product_title) + '</a>',
      hasDefaultVariant ? '' : '<span class="nt-cart__variant">' + escapeHtml(item.variant_title) + '</span>',
      controlsHtml,
      '</div>',
      '<div class="nt-cart__price">',
      wasPriceHtml,
      priceHtml,
      '</div>',
      discountsHtml ? '<div class="nt-cart__badges">' + discountsHtml + '</div>' : '',
      '</li>'
    ].join('');
  }

  function renderUpsells(cartVariantIds) {
    if (!config.upsells || !config.upsells.length) return '';
    var visible = [];
    for (var i = 0; i < config.upsells.length; i++) {
      var u = config.upsells[i];
      if (cartVariantIds.indexOf(u.id) === -1) visible.push(u);
    }
    if (!visible.length) return '';
    var html = '<div class="nt-cart__upsells"><p class="nt-cart__upsells-title">' + escapeHtml(config.upsells_title || 'You might also need') + '</p>';
    for (var j = 0; j < visible.length; j++) {
      var up = visible[j];
      html += '<div class="nt-cart__upsell" data-nt-upsell-id="' + up.id + '">';
      html += '<a href="' + escapeHtml(up.url) + '" class="nt-cart__upsell-thumb" tabindex="-1" aria-hidden="true">';
      if (up.image) html += '<img src="' + escapeHtml(up.image) + '" alt="" width="56" height="56" loading="lazy">';
      html += '</a>';
      html += '<div class="nt-cart__upsell-meta"><p class="nt-cart__upsell-name">' + escapeHtml(up.title) + '</p>';
      html += '<span class="nt-cart__upsell-price">' + escapeHtml(up.price_formatted) + '</span></div>';
      html += '<button type="button" class="nt-cart__upsell-add" data-nt-upsell-add="' + up.id + '"' + (up.available ? '' : ' disabled') + '>' + (up.available ? 'Add' : 'Sold out') + '</button>';
      html += '</div>';
    }
    html += '</div>';
    return html;
  }

  function rebuildBody(cart) {
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = renderEmpty();
      return;
    }
    var itemsHtml = '<ul class="nt-cart__items" data-nt-cart-items>';
    var variantIds = [];
    for (var i = 0; i < cart.items.length; i++) {
      itemsHtml += renderLineItem(cart.items[i], i + 1);
      variantIds.push(cart.items[i].variant_id || cart.items[i].id);
    }
    itemsHtml += '</ul>';
    body.innerHTML = itemsHtml + renderUpsells(variantIds);
  }

  function rebuildFoot(cart) {
    if (!foot) return;
    if (!cart.item_count) {
      foot.setAttribute('hidden', '');
      return;
    }
    foot.removeAttribute('hidden');

    /* Re-query rather than using the boot-time references. refreshFromSectionHtml
       replaces foot.innerHTML, which detaches every descendant captured at boot, so
       the cached nodes would still be written to while the visible footer stayed
       frozen on whatever it last showed (including an empty cart's $0.00). */
    var totalsNode = foot.querySelector('[data-nt-cart-totals]') || totalsEl;
    var subtotalNode = foot.querySelector('[data-nt-subtotal]') || subtotalEl;

    /* Rebuild totals block. Savings = max(MSRP-based was-total, Shopify-discount was-total) − final total.
       Captures both compare_at_price markdowns AND Shopify automatic discounts in one number. */
    if (totalsNode) {
      var wasTotal = 0;
      for (var ii = 0; ii < cart.items.length; ii++) {
        wasTotal += wasLinePrice(cart.items[ii]);
      }
      /* /cart.js carries no compare_at_price, so this JS path cannot see the gift's
         $97 (or the kit's MSRP) and would understate the saving. It is a fallback
         only: every normal update re-renders the section server-side, where Liquid
         can read compare_at. Add the gift's value back so the two agree if we ever
         land here. */
      if (GIFT_ID && GIFT.value_cents) {
        for (var gi = 0; gi < cart.items.length; gi++) {
          if (isGiftItem(cart.items[gi])) { wasTotal += Number(GIFT.value_cents); break; }
        }
      }
      var savings = Math.max(0, wasTotal - cart.total_price);
      var html = '';
      /* Order-level discount codes (whole-cart codes, e.g. email welcome codes) */
      var cartApps = cart.cart_level_discount_applications || [];
      var TAG_ICON_T = '<svg width="10" height="10" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 2h5.5L14 8.5 8.5 14 2 7.5V2z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="5.5" cy="5.5" r="1" fill="currentColor"/></svg>';
      for (var ai = 0; ai < cartApps.length; ai++) {
        var app = cartApps[ai];
        if (app.target_type === 'shipping_line') continue;
        html += '<div class="nt-cart__totals-row">';
        html += '<span class="nt-cart__discount nt-cart__discount--totals">' + TAG_ICON_T + escapeHtml(app.title || 'Discount') + '</span>';
        html += '<span class="nt-cart__totals-val nt-cart__totals-val--save">−' + formatMoney(app.total_allocated_amount || 0) + '</span>';
        html += '</div>';
      }
      if (savings > 0) {
        html += '<div class="nt-cart__totals-row nt-cart__totals-row--minor">';
        html += '<span class="nt-cart__totals-label">Original</span>';
        html += '<span class="nt-cart__totals-val nt-cart__totals-val--was">' + formatMoney(wasTotal) + '</span>';
        html += '</div>';
        html += '<div class="nt-cart__totals-row nt-cart__totals-row--save">';
        html += '<span class="nt-cart__totals-label nt-cart__totals-label--save">You saved</span>';
        html += '<span class="nt-cart__totals-val nt-cart__totals-val--save">−' + formatMoney(savings) + '</span>';
        html += '</div>';
      }
      html += '<div class="nt-cart__subtotal-row">';
      html += '<span class="nt-cart__subtotal-label">Total</span>';
      html += '<span class="nt-cart__subtotal-val" data-nt-subtotal>' + formatMoney(cart.total_price) + '</span>';
      html += '</div>';
      totalsNode.innerHTML = html;
    } else if (subtotalNode) {
      subtotalNode.textContent = formatMoney(cart.total_price);
    }

    var note = foot.querySelector('[data-nt-shipping-note]');
    if (!note) return;

    /* Auto-detect: does the cart already have a Shopify free-shipping discount applied? */
    var shippingApplied = false;
    var apps = cart.cart_level_discount_applications || [];
    for (var k = 0; k < apps.length; k++) {
      var a = apps[k];
      if (a.target_type === 'shipping_line') { shippingApplied = true; break; }
      if (a.title && /shipping/i.test(a.title)) { shippingApplied = true; break; }
    }

    note.classList.remove('nt-cart__shipping-note--ok');
    note.removeAttribute('hidden');

    if (shippingApplied) {
      note.classList.add('nt-cart__shipping-note--ok');
      note.textContent = '✓ FREE SHIPPING APPLIED';
    } else if (config.shipping_threshold > 0) {
      var thresholdCents = config.shipping_threshold * 100;
      if (cart.total_price >= thresholdCents) {
        note.classList.add('nt-cart__shipping-note--ok');
        note.textContent = '✓ ' + (config.shipping_note_above || 'FREE SHIPPING UNLOCKED');
      } else {
        var remaining = thresholdCents - cart.total_price;
        var template = config.shipping_note_below || 'Add [remaining] more for free shipping.';
        note.textContent = template.replace(/\[remaining\]/g, formatMoney(remaining));
      }
    } else {
      /* No threshold set and no Shopify discount applied — hide the line entirely */
      note.setAttribute('hidden', '');
      note.textContent = '';
    }
  }

  function updateBadge(count) {
    var badges = document.querySelectorAll('[data-nt-cart-badge]');
    badges.forEach(function (b) {
      if (count > 0) {
        b.textContent = count;
        b.removeAttribute('hidden');
        b.style.display = '';
      } else {
        b.setAttribute('hidden', '');
        b.style.display = 'none';
      }
    });
    if (headerCount) headerCount.textContent = '(' + count + ')';
  }

  function applyCart(cart) {
    rebuildBody(cart);
    rebuildFoot(cart);
    updateBadge(cart.item_count);
  }

  /* ---------- Section Rendering API (preferred path) ----------
     Instead of duplicating Liquid logic in JS (which misses variant.compare_at_price),
     we ask Shopify to re-render the cart-drawer section server-side and swap the fresh
     HTML into place. Liquid already knows about MSRP savings, Shopify discounts, free
     shipping detection, upsells, everything. Single source of truth. */
  var SECTION_ID = 'nytron-cart-drawer';

  function refreshFromSectionHtml(html) {
    if (!html) return false;
    var temp = document.createElement('div');
    temp.innerHTML = html;

    var newBody = temp.querySelector('[data-nt-cart-body]');
    if (newBody && body) body.innerHTML = newBody.innerHTML;

    var newFoot = temp.querySelector('[data-nt-cart-foot]');
    if (newFoot && foot) {
      foot.innerHTML = newFoot.innerHTML;
      if (newFoot.hasAttribute('hidden')) foot.setAttribute('hidden', '');
      else foot.removeAttribute('hidden');
    }

    var newCount = temp.querySelector('[data-nt-cart-count-text]');
    if (newCount && headerCount) headerCount.textContent = newCount.textContent;

    /* Parse "(N)" from the header count so badge stays accurate even when
       /cart/add.js response doesn't carry item_count. */
    if (newCount) {
      var m = newCount.textContent.match(/\d+/);
      if (m) updateBadge(parseInt(m[0], 10));
    }
    return true;
  }

  /* ---------- Network ---------- */
  function setLoading(on) { drawer.classList.toggle('is-loading', !!on); }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* ---------- Free gift reconciliation ----------
     One rule, enforced after every cart mutation: the gift is present exactly once
     whenever the cart holds something else, and absent otherwise. Absent-when-alone
     matters because a cart holding only the $0 line is a checkout-able $0 order.
     Returns the settled cart so callers can render from it. */
  function changeLineByKey(key, quantity) {
    return fetch(ROUTES.cart_change_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function addGift() {
    return fetch(ROUTES.cart_add_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: GIFT_ID, quantity: 1 }] })
    }).then(function (r) { return r.json(); });
  }

  function surveyGift(cart) {
    var out = { item: null, others: 0 };
    if (!cart || !cart.items) return out;
    for (var i = 0; i < cart.items.length; i++) {
      if (isGiftItem(cart.items[i])) out.item = cart.items[i];
      else out.others++;
    }
    return out;
  }

  /* The gift covers the kit, so its quantity mirrors the kit quantity: the sum of
     non-gift, non-upsell units in the cart. 2 kits -> 2 warranties; kit removed ->
     target 0 -> gift removed (a cart holding only the $0 line would be a
     checkout-able $0 order). */
  function giftTargetQty(cart) {
    var upsellIds = (config.upsells || []).map(function (u) { return Number(u.id); });
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (isGiftItem(it)) continue;
      if (upsellIds.indexOf(Number(it.variant_id || it.id)) > -1) continue;
      total += it.quantity || 0;
    }
    return total;
  }

  /* Runs after EVERY cart mutation and on boot. Only ever adjusts or removes an
     EXISTING gift line, never adds one, so a customer who removed the gift (or
     unticked the box) does not get it pushed back on them mid-session. */
  function tidyGift(cart) {
    if (!GIFT_ID || !cart || !cart.items) return Promise.resolve(cart);
    var g = surveyGift(cart);
    if (!g.item) return Promise.resolve(cart);
    var target = giftTargetQty(cart);
    if (g.item.quantity === target) return Promise.resolve(cart);
    return changeLineByKey(g.item.key, target).then(fetchCart).catch(function () { return cart; });
  }

  /* Runs only on add-to-cart, and only when the tick box says so. */
  function attachGift(cart) {
    if (!giftWanted() || !cart || !cart.items) return Promise.resolve(cart);
    var g = surveyGift(cart);
    if (g.item || g.others === 0) return Promise.resolve(cart);
    /* Re-read rather than trusting the response: /cart/add.js returns the added
       items, not the whole cart. Swallow failures so a problem attaching a free
       extra can never block the customer's real add-to-cart. */
    return addGift().then(fetchCart).catch(function () { return cart; });
  }

  function settleAfterAdd(cart) {
    return attachGift(cart).then(tidyGift);
  }

  /* Re-render the drawer server-side and swap it in. Liquid is the only renderer
     that can see variant.compare_at_price, so it is the only one that computes the
     real "Original" and "You saved" (the kit's MSRP and the warranty's $97).
     /cart.js omits compare_at entirely, so rendering from JS understated the saving.
     Falls back to the JS render if the section request fails. */
  function renderFromServer() {
    return fetch('/?sections=' + SECTION_ID, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data[SECTION_ID] && refreshFromSectionHtml(data[SECTION_ID])) return true;
        throw new Error('no section html');
      })
      .catch(function () {
        return fetchCart().then(function (cart) { applyCart(cart); return false; });
      });
  }

  /* Target lines by item.key, not positional index: keys survive re-renders and
     line removals, so a queued change can never hit the wrong row. The full-panel
     loading overlay is shown only for removals — for +/− taps it would sit over
     the buttons and eat every click made during the round-trip. */
  function changeLine(key, quantity) {
    var overlay = quantity === 0;
    if (overlay) setLoading(true);
    return fetch(ROUTES.cart_change_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: SECTION_ID })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { return tidyGift(data); })
      .then(function (data) {
        var html = data && data.sections && data.sections[SECTION_ID];
        if (html && refreshFromSectionHtml(html)) {
          if (typeof data.item_count === 'number') updateBadge(data.item_count);
          return;
        }
        /* tidyGift acted (its settled cart carries no section HTML) — re-render
           server-side so gift "× N" and the compare_at-based savings stay right. */
        return renderFromServer();
      })
      .catch(function () { return fetchCart().then(applyCart); })
      .finally(function () { if (overlay) setLoading(false); });
  }

  /* Rapid +/− clicks: show the new number immediately, then send ONE request with
     the final value once the clicks stop. Requests are chained so two changes can
     never race each other (three fast "+" used to send the same stale target three
     times and land on 2 instead of 4). */
  var qtyTimers = {};
  var changeChain = Promise.resolve();
  function enqueueChange(key, quantity) {
    changeChain = changeChain.then(function () { return changeLine(key, quantity); });
  }
  function debounceChange(key, quantity) {
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () {
      delete qtyTimers[key];
      enqueueChange(key, quantity);
    }, 300);
  }

  function addVariant(id, quantity) {
    setLoading(true);
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', quantity || 1);
    fd.append('sections', SECTION_ID);
    return fetch(ROUTES.cart_add_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: fd
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function (data) {
        /* With a gift configured we have to read the cart back to reconcile it, so the
           Section Rendering shortcut only helps when the feature is switched off. */
        if (!GIFT_ID) {
          var html = data && data.sections && data.sections[SECTION_ID];
          if (html && refreshFromSectionHtml(html)) {
            openDrawer();
            return;
          }
        }
        /* Fallback if Section Rendering API didn't return HTML for some reason */
        return fetchCart().then(settleAfterAdd).then(renderFromServer).then(function () { openDrawer(); });
      })
      .catch(function (err) {
        var msg = (err && err.description) || (err && err.message) || 'Could not add item to cart.';
        try { alert(msg); } catch (e) {}
      })
      .finally(function () { setLoading(false); });
  }

  function addFromForm(form) {
    var fd = new FormData(form);
    fd.append('sections', SECTION_ID);
    setLoading(true);
    return fetch(ROUTES.cart_add_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: fd
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function (data) {
        if (!GIFT_ID) {
          var html = data && data.sections && data.sections[SECTION_ID];
          if (html && refreshFromSectionHtml(html)) {
            openDrawer();
            return;
          }
        }
        return fetchCart().then(settleAfterAdd).then(renderFromServer).then(function () { openDrawer(); });
      })
      .catch(function (err) {
        var msg = (err && err.description) || (err && err.message) || 'Could not add item to cart.';
        try { alert(msg); } catch (e) {}
      })
      .finally(function () { setLoading(false); });
  }

  /* ---------- Delegated events inside the drawer ---------- */
  drawer.addEventListener('click', function (e) {
    var dec = e.target.closest('[data-nt-qty-dec]');
    var inc = e.target.closest('[data-nt-qty-inc]');
    var rm = e.target.closest('[data-nt-remove]');
    var upsell = e.target.closest('[data-nt-upsell-add]');

    if (dec || inc || rm) {
      var li = e.target.closest('[data-nt-line]');
      if (!li) return;
      var key = li.getAttribute('data-nt-line-key');
      if (!key) return;
      var valEl = li.querySelector('[data-nt-qty-val]');
      var current = parseInt((valEl || {}).textContent || '0', 10) || 0;
      if (rm) {
        clearTimeout(qtyTimers[key]);
        delete qtyTimers[key];
        enqueueChange(key, 0);
        return;
      }
      var next = dec ? Math.max(0, current - 1) : current + 1;
      if (valEl) valEl.textContent = next;
      debounceChange(key, next);
    } else if (upsell) {
      var id = upsell.getAttribute('data-nt-upsell-add');
      if (id) {
        upsell.disabled = true;
        addVariant(id, 1).finally(function () { upsell.disabled = false; });
      }
    }
  });

  /* ---------- Form interception (global) ----------
     Any <form action="/cart/add" ...> on the page is hijacked.
     This wires up Order Kit forms in hero / final-cta / buy-box automatically. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add(\b|\/?$)/.test(action)) return;
    if (form.hasAttribute('data-nt-cart-skip')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"], [name="add"]');
    if (btn) btn.disabled = true;
    addFromForm(form).finally(function () { if (btn) btn.disabled = false; });
  });

  /* Signal readiness + process any Add-to-Cart submits captured by the early inline guard
     (in nytron-cart-drawer.liquid) before this deferred script attached its handler. */
  window.__ntCartReady = true;
  if (window.__ntCartPending && window.__ntCartPending.length) {
    window.__ntCartPending.splice(0).forEach(function (form) { addFromForm(form); });
  }

  /* ---------- Boot: sync badge with real cart on first load ----------
     Tidy only. A restored cart that never had the gift is a cart the customer either
     built before this shipped or actively unticked, and neither is ours to override. */
  fetchCart()
    .then(function (cart) {
      updateBadge(cart.item_count);
      if (!GIFT_ID) return null;
      return tidyGift(cart).then(function (settled) {
        if (settled && settled.item_count !== cart.item_count) applyCart(settled);
      });
    })
    .catch(function () {});
})();
